
import React from 'react'
import Card from '../../components/card'
import { AuthContext } from '../../main/authProvider'
import { withRouter } from 'react-router-dom'
import PedidosCompraTable from '../../components/nf/pedidosCompraTable'
import DateIntervalCalendar from '../../components/calendar/dateIntervalCalendar'
import ConstantsUtil from '../../context/constantsUtil'
import GeneralServices from '../../app/service/generalServices'
import { Button } from 'primereact/button'


class ValidacaoPedidosCompra extends React.Component {

    constructor(){
        super()
        this.generalServices = new GeneralServices()
    }
    
    state = {
        
        selectedDateFilterType: '',
        missingFilterType: false,
        missingAnyDate: false,
        initialDate: '',
        initialDateView: '',
        finalDate: '',
        finalDateView: '',
        
        habilitaBusca: true,
        loading: false,

    }

    componentDidMount(){
        this.autoSearch()
    }

    autoSearch = async () => {
        await this.generalServices.sleep(100)
        this.search()
    }

    handleDateFilterChange = (selectedDateFilterType) => {
        this.setState({selectedDateFilterType})
    }

    handleDateChange = async (initialDate, finalDate) => {
        await this.setState({initialDate})
        // console.log("handleDateChange initial: ", this.state.initialDate)
        
        await this.setState({initialDateView: GeneralServices.convertBrStringToJsDate(initialDate)})
        // console.log("handleDateChange initialView: ", this.state.initialDateView)

        await this.setState({finalDate})
        await this.setState({finalDateView: GeneralServices.convertBrStringToJsDate(finalDate)})

    }

    getDataInicial = () => {
        if(this.props.dataInicial){
            //Recebeu dhEmi da NF
            let dataInicial = GeneralServices.convertBrStringToJsDate(this.props.dataInicial)
            dataInicial.setDate(dataInicial.getDate() - 30)
            return dataInicial            
        }
        else{
            let dataInicial = new Date()
            dataInicial.setDate(dataInicial.getDate() - 30)
            return dataInicial;
        }

    }

    getDataFinal = () => {
        
        if(this.props.dataInicial){
            //Recebeu dhEmi da NF
            return GeneralServices.convertBrStringToJsDate(this.props.dataInicial)
        }

        else{
            return new Date()
        }
        

    }

    toggleButton = () => {
        this.setState({habilitaBusca: !this.state.habilitaBusca})
    }

    resetView = () => {

        this.setState({missingFilterType: false})
        this.setState({missingAnyDate: false})

        this.setState({inputEmpresasErrorClass: ''})
        this.setState({errorEmpresasErrorMessage: ''})

    }

    checkData = () => {

        var check = true

        if(!this.state.selectedDateFilterType){
            this.setState({missingFilterType: true})
            check=false
        }
        
        if(!this.state.initialDate || !this.state.finalDate){
            this.setState({missingAnyDate: true})
            check=false
        }

        return check
    }

    search = () => {

        this.resetView()

        if(this.checkData()){
            this.setState({habilitaBusca: false})
        }

    }

    render(){

        const renderButtons = () => {
            if(this.state.habilitaBusca){
                return (
                    <Button
                        label="Buscar"
                        icon="pi pi-search"
                        className='small-button'
                        onClick = {this.search}
                    />
                )
            }
            return (
                <>
                    <Button 
                        label="Voltar"
                        icon="pi pi-undo"
                        className="p-button-danger small-button"
                        onClick = {() => {
                            this.setState({filterNFTableState: {}})
                            this.toggleButton()
                        }}
                    />
                </>
            )            
        }

        const renderTable = () => {
            if(!this.state.habilitaBusca)
            return(
                <div className="row">
                <div className = "col-md-12">
                    <PedidosCompraTable
                        link = {this.props.link}
                        pedidosLinkadosId={this.props.pedidosLinkadosId}
                        insideDialog={this.props.insideDialog}
                        initialDate={this.state.initialDate}
                        finalDate={this.state.finalDate}
                        scrollHeight={this.props.scrollHeight}
                    />

                </div>
                </div>
            )
        }

        return(
            <div className="bs-docs-section" >
                
                <Card title = "Pedidos de Compra">
                    <div className = "col-md-12">
                    <div className="row">

                        <DateIntervalCalendar
                            htmlFor="SelectDatePeriod"
                            // defaultValue={ConstantsUtil.calendarPersonalizadoFilterLabel}
                            handleFilterChange={this.handleDateFilterChange}
                            handleDateChange={this.handleDateChange}
                            missingFilterType={this.state.missingFilterType}
                            missingAnyDate={this.state.missingAnyDate}
                            disabled={!this.state.habilitaBusca}
                            preSetFilterType={ConstantsUtil.calendarPersonalizadoFilterLabel}
                            preSetDataInicial={this.getDataInicial()}
                            preSetDataFinal={this.getDataFinal()}
                            enableChangeFilterType
                        />
                    </div>

                    <div
                        style={{marginTop: '0.5rem', marginBottom: '0.5rem'}}
                    >
                        {renderButtons()}
                    </div>

                    {renderTable()}

                    </div>
                </Card>
                <div className="d-flex "/>
            </div>
        )
    }

}

ValidacaoPedidosCompra.contextType = AuthContext

export default withRouter(ValidacaoPedidosCompra)